module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n\r\n#propMainMisc input[type=checkbox]{\r\n    margin-right: 5px;\r\n}\r\n\r\n</style>\r\n<div class=\"prop-header\" xmlns=\"http://www.w3.org/1999/html\"><span class=\"prop-label\">App</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-9\" style=\"padding-right: 4px!important;\">\r\n        <input type=\"text\" name=\"formName\" id=\"formName\" readonly value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.formName ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-3 nopadding\" style=\"text-align: right;\">\r\n        <button name=\"selectedFormButton\" id=\"selectedFormButton\" class=\"btn btn-default hvr-glow select-button\"> Select </button>\r\n    </div>\r\n</div>")
  }
  return __output;

}